var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_931_2779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0.112C24.9438 0.119762 18.1788 2.92607 13.1891 7.91528C8.19942 12.9045 5.39244 19.6692 5.38397 26.7253C5.38397 33.5787 10.6906 44.304 21.1573 58.6027C22.4033 60.3097 24.0348 61.6984 25.9189 62.6557C27.803 63.6131 29.8866 64.1121 32 64.1121C34.1134 64.1121 36.1969 63.6131 38.081 62.6557C39.9652 61.6984 41.5966 60.3097 42.8426 58.6027C53.3093 44.304 58.616 33.5787 58.616 26.7253C58.6075 19.6692 55.8005 12.9045 50.8108 7.91528C45.8211 2.92607 39.0561 0.119762 32 0.112V0.112ZM32 37.3333C29.8903 37.3333 27.828 36.7077 26.0739 35.5357C24.3198 34.3636 22.9526 32.6977 22.1453 30.7486C21.3379 28.7995 21.1267 26.6548 21.5383 24.5857C21.9498 22.5166 22.9657 20.616 24.4575 19.1242C25.9493 17.6324 27.8499 16.6165 29.919 16.205C31.9881 15.7934 34.1329 16.0046 36.0819 16.812C38.031 17.6193 39.6969 18.9865 40.869 20.7406C42.041 22.4947 42.6666 24.557 42.6666 26.6667C42.6666 29.4956 41.5428 32.2087 39.5424 34.2091C37.5421 36.2095 34.8289 37.3333 32 37.3333Z",
    fill: "#1E7C88"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_931_2779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.5dee58d64a68cb5594814a034dff8a38.svg";
export { ForwardRef as ReactComponent };